import React, { useContext, useEffect, useState } from 'react'
import { Layout, Menu, Button, Drawer, Typography, Space } from 'antd'
import {
  MenuOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
  HomeOutlined,
  LoginOutlined,
  PlusOutlined,
  LogoutOutlined
} from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import AppContext from '../context/Context'
import logo from '../images/logo.png'

const { Header: AntHeader } = Layout
const { Text } = Typography

export default function Header () {
  const [visible, setVisible] = useState(false)
  const [isHeaderVisible, setIsHeaderVisible] = useState(true)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const { user, setUser, setEditMode } = useContext(AppContext)
  const history = useHistory()

  const whats =
    'https://wa.me/5522999666419?text=Ol%C3%A1,%0A%0AEstou%20interessado(a)%20em%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20oferecidos%20pela%20sua%20imobili%C3%A1ria.'
  const scrollLimit = 600
  const mobileBreakpoint = 768

  // Verifica usuário
  useEffect(() => {
    const isAdmin = JSON.parse(localStorage.getItem('user'))
    setUser(isAdmin)
  }, [setUser])

  // Controla header ao rolar
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      setIsHeaderVisible(scrollY < scrollLimit)
    }

    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const toggleDrawer = () => {
    setVisible(!visible)
    if (!visible) {
      document.body.classList.add('disable-scroll')
    } else {
      document.body.classList.remove('disable-scroll')
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('user')
    setUser(null)
    history.push('/login')
  }

  return (
    <AntHeader
      style={{
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        position: 'fixed',
        padding: 0,
        top: 0,
        left: 0,
        width: '100vw',
        zIndex: 1000,
        transform: isHeaderVisible ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'transform 0.4s ease-in-out',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        height: 100
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          padding: 15
        }}
      >
        {/* Logo */}
        <div
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
          onClick={() => history.push('/')}
        >
          <img src={logo} alt="Logo" style={{ height: 200, width: 200, marginTop: 10 }} />
        </div>

        {/* Menu Desktop */}
        {windowWidth > mobileBreakpoint && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Menu
              mode="horizontal"
              style={{
                borderBottom: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}
            >
              <Menu.Item
                key="home"
                icon={<HomeOutlined />}
                onClick={() => history.push('/')}
                style={{ color: '#623d19ff' }}
              >
                Imóveis
              </Menu.Item>
              <Menu.Item
                key="contact"
                icon={<PhoneOutlined />}
                style={{ color: '#623d19ff' }}
              >
                <a href={whats} target="_blank" rel="noreferrer">
                  Fale Conosco
                </a>
              </Menu.Item>
              {!user && (
                <Menu.Item
                  key="login"
                  icon={<LoginOutlined />}
                  style={{ color: '#623d19ff' }}
                  onClick={() => history.push('/login')}

                >
                  Login
                </Menu.Item>
              )}
              {user && user.role === 'admin' && (
                <Menu.Item
                  key="add"
                  icon={<PlusOutlined />}
                  style={{ color: '#623d19ff' }}

                  onClick={async () => {
                    await setEditMode(false)
                    history.push('/products')
                  }}
                >
                  Cadastrar Imóvel
                </Menu.Item>
              )}
              {user && (
                <Menu.Item
                  key="logout"
                  icon={<LogoutOutlined />}
                  style={{ color: '#623d19ff' }}
                  onClick={handleLogout}
                >
                  Logout
                </Menu.Item>
              )}
            </Menu>
          </div>
        )}

        {/* Botão Drawer Mobile */}
        {windowWidth <= mobileBreakpoint && (
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={toggleDrawer}
            style={{
              fontSize: 24,
              color: '#000'
            }}
          />
        )}

        {/* Drawer Mobile */}
        <Drawer
          title="Menu"
          placement="right"
          closable
          onClose={toggleDrawer}
          open={visible}
        >
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {!user && (
              <Button
                block
                icon={<LoginOutlined />}
                onClick={() => history.push('/login')}
              >
                Login
              </Button>
            )}
            {user && user.role === 'admin' && (
              <Button
                block
                icon={<PlusOutlined />}
                onClick={() => history.push('/products')}
              >
                Cadastrar Imóvel
              </Button>
            )}
            {user && (
              <Button block icon={<LogoutOutlined />} onClick={handleLogout}>
                Logout
              </Button>
            )}
            <Button
              block
              icon={<WhatsAppOutlined />}
              href={whats}
              target="_blank"
              style={{ backgroundColor: '#25D366', color: '#fff' }}
            >
              Fale Conosco
            </Button>
            <div style={{ marginTop: 16 }}>
              <Text strong>Telefone:</Text>
              <br />
              <Text strong>+55 (22) 9996-66419</Text>
            </div>
          </Space>
        </Drawer>
      </div>
    </AntHeader>
  )
}
